import { Check } from "lucide-react";

const STEPS = [
  { label: "Your Details" },
  { label: "Choose Your Services" },
  { label: "Review Your Plan" },
  { label: "Your Preferences" },
];

export function StepProgressIndicator({ currentStep = 1 }) {
  return (
    <div className="w-full px-4 py-3" data-testid="step-progress-indicator">
      {/* Step label */}
      <p className="text-xs text-center text-muted-foreground mb-3 tracking-wide">
        Step {currentStep} of {STEPS.length}: <span className="font-medium text-foreground">{STEPS[currentStep - 1]?.label}</span>
      </p>

      {/* Progress bar */}
      <div className="flex items-center gap-1.5 max-w-xs mx-auto">
        {STEPS.map((step, i) => {
          const stepNum = i + 1;
          const isCompleted = stepNum < currentStep;
          const isActive = stepNum === currentStep;

          return (
            <div key={i} className="flex-1 flex items-center gap-1.5">
              <div className="flex-1 relative">
                <div className="h-1 rounded-full bg-border/60" />
                <div
                  className="absolute inset-0 h-1 rounded-full transition-all duration-500"
                  style={{
                    width: isCompleted ? "100%" : isActive ? "50%" : "0%",
                    background: isCompleted || isActive
                      ? "linear-gradient(90deg, var(--agent-primary, #8B7355), var(--agent-primary, #8B7355))"
                      : "transparent",
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
